import { Address } from "./address";
import { Entity } from "./entity";
import { AccountOrigin, FamilleLaverie } from "./enum-type";

export interface Account extends Entity {
  date?: string
  siret?: string
  email: string
  website?: string
  telephone: string
  signataire: string;
  fonctionSignataire: string
  address: Address
  famille?: FamilleLaverie
  origineCompte: AccountOrigin
  porteurProjet: string
  observation: string
  nbLaveries: number
}

export class AccountExport {
  acnts: Account[];
}

export function getAccountExport(accounts: Account[]): AccountExport {
  const accountExport = new AccountExport();
  accountExport.acnts = accounts;
  return accountExport;
}